module.exports = __webpack_public_path__ + "media/sub3-1.b6df85ce.mp4";